
const digest = 'b29409e19f43b4af88f376c9386aa593331fb518d4fd818aa7af24081cf37795';
const classes = {"item":"_item_1eulz_1","cross":"_cross_1eulz_15","crossIcon":"_crossIcon_1eulz_31","avatar":"_avatar_1eulz_34","name":"_name_1eulz_47","info":"_info_1eulz_52"};
const css = `._item_1eulz_1 {
  font-family: "Rubik", sans-serif;
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  padding: 24px 16px;
  border: 1px solid #aeb8cb;
  border-radius: 10px;
  background-color: #ffffff;
  cursor: pointer;
  position: relative;
  text-align: center;
}
._item_1eulz_1 ._cross_1eulz_15 {
  position: absolute;
  top: 6px;
  right: 6px;
  background: #f12848;
  border: none;
  color: #ffffff;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  cursor: pointer;
}
._item_1eulz_1 ._cross_1eulz_15 ._crossIcon_1eulz_31 {
  display: block;
}
._item_1eulz_1 ._avatar_1eulz_34 {
  width: 80px;
  height: 80px;
  border-radius: 100%;
  background: #e5ecfb;
  color: #1665d8;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  font-weight: 600;
  text-transform: uppercase;
}
._item_1eulz_1 ._name_1eulz_47 {
  font-size: 16px;
  font-weight: 600;
  color: #000000;
}
._item_1eulz_1 ._info_1eulz_52 {
  font-size: 13px;
  color: #787c88;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  